export enum WELCOME_TRIAL_VERSION {
	V1 = 'welcomeTrialV1',
}
